import Slider from './Slider';
export default Slider;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Slider/index.tsx
// module id = 1480
// module chunks = 0